var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeCoverDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1401,
    height: 1078,
    viewBox: "0 0 1401 1078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1401,
    height: 1078,
    transform: "translate(-8568 1267)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8568 -1267)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.411,2.073C36.469,156.765-108,491.371,101.451,655.807s-196.21,388.108,466.482,565.448c470.108,125.8,566.977-222.032,815.332-190.808,306.175,38.491,506.541-229.634,494.371-552.641C1867.552,210.141,1751.392,0,1751.392,0Z",
    transform: "translate(-8116.412 525.157) rotate(36)",
    fill: "#0533b3",
    opacity: 0.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCoverDecor);
export default __webpack_public_path__ + "static/media/home-cover-decor.3284cbdc907bec061c1565be7c23e729.svg";
export { ForwardRef as ReactComponent };